/*
 * @Author: Chao Yang
 * @Date: 2020-09-10 08:22:08
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-10-22 13:43:14
 */
import {
  Component,
  forwardRef,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AdDateRangeModel } from './ad-date-range-model';
import { DateRangeTypeEnum } from './date-range-type.enum';

@Component({
  selector: 'date-range-common',
  templateUrl: './date-range-common.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangeCommonComponent),
      multi: true,
    },
  ],
})
export class DateRangeCommonComponent
  implements OnInit, OnDestroy, ControlValueAccessor {
  //#region NgModel
  _rangeDates: AdDateRangeModel;
  _disabled: boolean;

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(val: boolean) {
    this._disabled = val;
  }

  @Input()
  autofocus = true;

  set rangeDates(value: AdDateRangeModel) {
    this.valueOnChange(value);
    this._rangeDates = value;
  }

  get rangeDates() {
    return this._rangeDates;
  }
  valueOnChange = (v: AdDateRangeModel) => { };
  valueOnTouch = () => { };

  writeValue(obj: AdDateRangeModel): void {
    this._rangeDates = obj;
    if (this._rangeDates) {
      this.dateRangeType = this._rangeDates.type;
    }
  }
  registerOnChange(fn: any): void {
    this.valueOnChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.valueOnTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
    this.cd.markForCheck();
  }
  //#endregion
  itdStartDate: Date = new Date(1900, 0, 1);
  dateRangeTypeEnum = DateRangeTypeEnum;
  dateRangeType: DateRangeTypeEnum = DateRangeTypeEnum.itd;
  tempDateRangeType: DateRangeTypeEnum = DateRangeTypeEnum.itd;
  tempRangeDates: AdDateRangeModel = new AdDateRangeModel();
  startFormatFun = (value, dateRange: AdDateRangeModel) => {
    if (
      dateRange &&
      (dateRange.startDate === undefined ||
        dateRange.startDate === null ||
        dateRange.startDate.getTime() == this.itdStartDate.getTime())
    ) {
      return 'ITD';
    }
    return value;
  };


  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private cd: ChangeDetectorRef,) { }

  beforeClose() { }

  customToolEventHandler() { }

  onDateRangeChange(event) {
    if (event.value.startDate === null && event.value.endDate === null) return;
    this.dateRangeType = this.tempDateRangeType;
    this.rangeDates = event.value;
    this.tempDateRangeType = null;
    this.onChange.emit(event);
  }

  ngOnDestroy() { }

  ngOnInit() {
    console.log(this._rangeDates);
  }

  onToolbarChange(e: any) {
    this.tempDateRangeType = e.type;
    this.tempRangeDates.startDate = e.dateRange.start;
    this.tempRangeDates.endDate = e.dateRange.end;
  }
}
